import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    function fillProportionally(_el, _parent) {
        var elementRatio = _el.clientWidth / _el.clientHeight;
        var parentRatio = _parent.clientWidth / _parent.clientHeight;
        var isVertical = window.innerHeight > window.innerWidth;
        var caption = $(_parent).find(".dynamic-caption")[0];
        var scrollIndicator = $(_parent).find(".scroll-indicator")[0];
        var conditionMet =
            ($(_el).hasClass("fill-proportionally") && !$(_el).hasClass("ver:fit-proportionally")) ||
            ($(_el).hasClass("fill-proportionally") && $(_el).hasClass("ver:fit-proportionally") && !isVertical) ||
            ($(_el).hasClass("ver:fill-proportionally") && isVertical);

        if (conditionMet) {
            if (elementRatio >= parentRatio) {
                _el.style.width = "auto";
                _el.style.height = "100%";
            } else {
                _el.style.width = "100%";
                _el.style.height = "auto";
            }
            var offsetX = (_parent.clientWidth - _el.clientWidth) / 2;
            var offsetY = (_parent.clientHeight - _el.clientHeight) / 2;
            _el.style.top = `${offsetY}px`;
            _el.style.left = `${offsetX}px`;

            caption.style.bottom = elementRatio >= parentRatio ? `${-offsetY}px` : 0;
            caption.style.left = elementRatio >= parentRatio ? 0 : `${-offsetX}px`;
            scrollIndicator.style.top = elementRatio >= parentRatio ? `${-offsetY}px` : 0;
            scrollIndicator.style.left = elementRatio >= parentRatio ? 0 : `${-offsetX}px`;
        }
    }
    $(window).on("load", function () {
        if ($(".fill-proportionally, .ver\\:fill-proportionally").length) {
            if (globals.debug) console.log("component-fill-proportionally initialized");
            $(".fill-proportionally, .ver\\:fill-proportionally").each(function () {
                var el = $(this)[0];
                var parent = $(this).parent()[0];
                parent.style.position = "relative";
                el.style.position = "absolute";
                fillProportionally(el, parent);
            });
            $(window).on("resizeEnd", function () {
                $(".fill-proportionally, .ver\\:fill-proportionally").each(function () {
                    var el = $(this)[0];
                    var parent = $(this).parent()[0];
                    fillProportionally(el, parent);
                });
            });
        }
    });
})();
export default component;
